import api from '../services/api';
import { ISpecialty } from '../shared/interfaces';

interface IResponseGetSpecialties {
  data: ISpecialty[];
  count: number;
}
export const getSpecialties = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetSpecialties> => {
  const response = await api.post('/specialties/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postSpecialty = async (payload: any): Promise<ISpecialty> => {
  const response = await api.post(`/specialties`, payload);
  return response.data;
};

export const patchSpecialty = async (
  id: string | undefined,
  payload: any,
): Promise<ISpecialty> => {
  if (!id) {
    throw new Error('ID do plano de contas não fornecido.');
  }
  const response = await api.patch(`/specialties/${id}`, payload);
  return response.data;
};

export const getSelectSpecialties = async (): Promise<ISpecialty[]> => {
  const response = await api.get(`/specialties/select`);
  return response.data;
};
